export default "__VITE_PUBLIC_ASSET__57807296__"